import { useMemo } from "react";
import {
	Datagrid,
	EditButton,
	Filter,
	List,
	ShowButton,
	TextField,
	TextInput,
	usePermissions,
} from "react-admin";
import { constants, rolesGlobal } from "../../utils/constants";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import { CustomDeleteButtonWithCustomConfirm } from "../../customComponents/CustomButtons";

const TaskFilter = (props) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
	</Filter>
);

export const TaskList = (props) => {
	const { permissions, isLoading } = usePermissions();
	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);
	if (isLoading) return null;
	const hideActions = permissions?.includes(rolesGlobal.coach);
	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<TaskFilter />}
		>
			<Datagrid>
				<TextField source={`name.${defaultLocale}`} sortable={false} />
				<TextField source="taskEventName" label={"Event"} />
				{hideActions === false ? (<EditButton />) : null}
				<ShowButton />
				{hideActions === false ? (<CustomDeleteButtonWithCustomConfirm mutationMode="pessimistic" />) : null}
			</Datagrid>
		</List>
	);
};

export default TaskList;
